import { useEffect } from 'react';
import { useState } from 'react';
import { FormHelperText, Grid, InputLabel, Typography } from '@material-ui/core';
import { SecondaryButton, TextBox } from '../../../../../../Core/FormInput';
import { postJobProgressAwaitingAuthority } from '../../../../../../Core/Service/communicator-service';
import { useContext } from 'react';
import AppContext from '../../../../../../App/AppContext';
import { singleEmailValidation } from '../../../../../../Core/Service/StaticService';

const AwaitingAuthorityModal = (props) => {
    const { showToast } = useContext(AppContext);

    const [state, setState] = useState({
        messaegList: [],
        actionLog: false,
        editActionLog: false,
        selectedStatus: props.selectedStatus,
        logText: '',
        orderNumber: '',
        isPhoneVisible: false,
        isEmailVisible: false,
        errors: {}
    });

    useEffect(() => {
        let obj = props.statusList || {};
        setState((st) => ({
            ...st,
            isCustomerUpdate: obj?.sendEmail,
            isUpdateSms: obj?.sendSMSUpdate,
            isCustomerEmail: obj?.email,
            isPhoneNo: obj?.phone,
            logText: obj?.smsText,
            isPhoneVisible: obj?.sendSMSUpdate,
            isEmailVisible: obj?.sendEmail,
            noDataVisible: !obj.sendSMSUpdate && !obj.sendEmail
        }));
    }, [props.statusList]);

    const handleInput = (e) => {
        const { name, value, type, checked } = e.target;
        if (type == 'checkbox') {
            setState((st) => {
                let newSt = { ...st };
                newSt[name] = checked;
                if (!newSt.isCustomerUpdate) {
                    newSt.isCustomerEmail = '';
                }
                if (!newSt.isUpdateSms) {
                    newSt.isPhoneNo = '';
                }
                return newSt;
            });
        } else {
            setState((st) => ({ ...st, [name]: value }));
        }
    };

    const validation = () => {
        let { partStatus, orderNumber, isCustomerUpdate, isCustomerEmail, isUpdateSms, isPhoneNo } = state;
        let isValid = true;
        let errors = {};

        // if (!orderNumber) {
        //     isValid = false;
        //     errors.orderNumber = 'Order Number is required';
        // }
        if (isCustomerUpdate && !singleEmailValidation(isCustomerEmail)) {
            isValid = false;
            errors.isCustomerEmail = 'Please Add Customer Email';
        }
        if (isUpdateSms && !isPhoneNo) {
            isValid = false;
            errors.isPhoneNo = 'Please Add Customer Email';
        }

        setState((st) => ({ ...st, errors: errors }));
        return isValid;
    };

    const handleSubmit = async () => {
        if (validation()) {
            let data = {
                // headerRecordID: props.headerRecordID,
                tCardID: props.tCardID,
                orderNumber: state.orderNumber,
                status: +state.selectedStatus,
                logText: state.logText,
                isPhoneNo: state.isPhoneNo,
                isCustomerEmail: state.isCustomerEmail
            };
            let res = await postJobProgressAwaitingAuthority(data);
            if (res.success) {
                showToast(`Awaiting Authority Added Successfully`);
                props.onClose(true);
            } else {
                showToast(`Awaiting Authority Failed To Add`);
            }
        }
    };

    return (
        <div>
            <Grid container spacing={2}>
                <Grid item xs={6}>
                    <InputLabel shrink>Order Number</InputLabel>
                    <TextBox type="text" name="orderNumber" value={state.orderNumber} variant="outlined" fullWidth onChange={handleInput} />
                    <FormHelperText error>{state.errors.orderNumber}</FormHelperText>
                </Grid>
                {(state.isPhoneVisible || state.isEmailVisible) && (
                    <Grid item xs={12}>
                        <Typography color="secondary">Customer Message</Typography>
                        <TextBox
                            placeholder="Message"
                            multiline
                            rows={3}
                            type="text"
                            name="logText"
                            variant="outlined"
                            fullWidth
                            value={state.logText}
                            onChange={handleInput}
                        />
                        <FormHelperText error>{state.errors.logText}</FormHelperText>
                    </Grid>
                )}
                {state.isEmailVisible && (
                    <Grid item xs={12}>
                        <InputLabel shrink>
                            <input
                                type="checkbox"
                                style={{ cursor: 'pointer' }}
                                name="isCustomerUpdate"
                                onChange={handleInput}
                                checked={state.isCustomerUpdate}
                            />
                            Customer Email
                        </InputLabel>
                        <TextBox
                            placeholder="Email update to customer"
                            type="email"
                            name="isCustomerEmail"
                            variant="outlined"
                            fullWidth
                            value={state.isCustomerEmail}
                            onChange={handleInput}
                            error={state.isCustomerUpdate}
                        />
                        <FormHelperText error>{state.errors.isCustomerEmail}</FormHelperText>
                    </Grid>
                )}
                {state.isPhoneVisible && (
                    <Grid item xs={12}>
                        <InputLabel shrink>
                            <input type="checkbox" style={{ cursor: 'pointer' }} onChange={handleInput} name="isUpdateSms" checked={state.isUpdateSms} />
                            Phone Number
                        </InputLabel>
                        <TextBox
                            placeholder="Phone Number"
                            type="tel"
                            name="isPhoneNo"
                            variant="outlined"
                            fullWidth
                            value={state.isPhoneNo}
                            onChange={handleInput}
                            error={state.isUpdateSms}
                        />
                        <FormHelperText error>{state.errors.isPhoneNo}</FormHelperText>
                    </Grid>
                )}
                <Grid item xs={12}>
                    <SecondaryButton className="Submitbtn" fullWidth onClick={handleSubmit}>
                        Awaiting Authority
                    </SecondaryButton>
                </Grid>
            </Grid>
        </div>
    );
};

export default AwaitingAuthorityModal;
